/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import Calendar from "components/Calendar/Calendar.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import Datetime from 'react-datetime';

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSCheckBox from "components/Forms/TSCheckBox";
import TSSelect2 from "components/Forms/TSSelect2";
import { Collapse, Modal, ModalBody } from "reactstrap";

import TSUser from "components/Forms/TSUser";
// import avatar from "assets/img/faces/marc.jpg";
import {
    Input,
    Label,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }, { id: 6, forecolor: '#6D4C41' }, { id: 12, forecolor: '#0077ff' }]

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);


const Home = (props) => {
    var moment = require('moment');
    require('moment/locale/th');
    const [room1, setRoom1] = useState([]);
    const [room2, setRoom2] = useState([]);
    const [room3, setRoom3] = useState([]);
    const [room4, setRoom4] = useState([]);
    const [room5, setRoom5] = useState([]);
    const [room6, setRoom6] = useState([]);
    const [room7, setRoom7] = useState([]);
    const [roomAll, setRoomAll] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));
    const [RoomKey, setRoomKey] = useState(0);
    const [ArrRoom, setArrRoom] = useState([]);
    const [MeetingKey, setMeetingKey] = useState(null);
    const [MeetingName, setMeetingName] = useState("");
    const [MeetingTypeKey, setMeetingTypeKey] = useState(null);
    const [IsUrgent, setIsUrgent] = useState(false);
    const [StartDate, setStartDate] = useState("");
    const [StartType, setStartType] = useState("");

    const [IsMoreDate, setIsMoreDate] = useState(false);
    const [EndDate, setEndDate] = useState("");
    const [EndType, setEndType] = useState("");
    const [MeetingDescription, setMeetingDescription] = useState('');

    const [ContactAddress, setContactAddress] = useState('');
    const [ContactPhone, setContactPhone] = useState('');



    const [modalHoliday, setModalHoliday] = useState(false);
    const [holidayText, setHolidayText] = useState('');
    const [currentDate, setcurrentDate] = useState(moment());
    const [holidays, setHolidays] = useState([]);
    const [Attendee, setAttendee] = useState([]);

    const [IsCancel, setIsCancel] = useState(false);

    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modal3, setModal3] = useState(false);
    const [modal4, setModal4] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [icon2, setIcon2] = useState("far fa-question-circle");

    const [isOpen, setIsOpen] = useState(false);
    const [isShowCalendar, setIsShowCalendar] = useState(true);

    const [dateFocus, setDateFocus] = useState(false);

    const urgentList = [{ label: "ปกติ", value: 0 }, { label: "ด่วน", value: 1 }, { label: "ฉุกเฉิน", value: 2 }];
    const dateTypeList = [{ label: "ทั้งวัน", value: 0 }, { label: "ครึ่งวันเช้า", value: 1 }, { label: "ครึ่งวันบ่าย", value: 2 }];

    const myRef = useRef(null);

    useEffect(() => {

        axios("/api/v1/meeting/room0")
            .then(
                result => {

                    var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"roomKey":').join('"value":'));

                    setArrRoom(json)
                    getMeeting()
                }, error => { console.log(error); }
            );


    }, [])


    const getMeeting = () => {
        axios.get('/api/v1/meeting/header/')
            .then(
                result => {

                    var json = JSON.parse(JSON.stringify(result.data.data)
                        .split('"meetingName":').join('"title":')
                        .split('"startDatetime":').join('"start":')
                        .split('"endDatetime":').join('"end":')
                        .split('"meetingID":').join('"id":'));
                    if (json.length >= 0) {
                        setRoomAll(json);
                        console.log(json)
                        const r1 = json.filter(e => e.roomKey == 1);
                        const r2 = json.filter(e => e.roomKey == 2);
                        const r3 = json.filter(e => e.roomKey == 3);
                        const r4 = json.filter(e => e.roomKey == 4);
                        const r5 = json.filter(e => e.roomKey == 5);
                        const r6 = json.filter(e => e.roomKey == 6);
                        const r7 = json.filter(e => e.roomKey == 12);
                        setRoom1(r1);
                        setRoom2(r2);
                        setRoom3(r3);
                        setRoom4(r4);
                        setRoom5(r5);
                        setRoom6(r6);
                        setRoom7(r7);
                        setIsLoading(false);
                    }

                },
                error => { alert(error); }
            );
    }

    const handleSubmit = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var errMsg = [];
        /*
          if (name === null || name === "") {
            cntErr += 1;
            errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อตัวชี้วัด"}</li>);
          }
      
          if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
          } else {
            setModal(true);
          }
        */
    };

    const handleConfirm = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    };



    useEffect(() => {


    }, []);



    const test = e => {
        myRef.current.scrollIntoView()
    };

    const handleStartDate = (date) => {
        setStartDate(date);




    }
    const handleEndDate = (date) => {
        setEndDate(date);




    }

    const fetchHoliday = (yearMonth) => {

    };

    const handleCurrentDate = (dayAmt, unit) => {
        var curr = moment(currentDate).add(dayAmt, unit)
        setcurrentDate(curr);
        fetchHoliday(curr.format('YYYY/M'));
        return false;
    }

    const handleNavigate = (nextView, currentView, currDate) => {
        if (nextView == 'days') {
            setcurrentDate(currDate);
            fetchHoliday(currDate.format('YYYY/M'));
        }
        return nextView;
    }

    const handleHoliday = (txt) => {
        setHolidayText(txt);
        setModalHoliday(true);
    }

    const handleDateClick = (args) => {
        setDefaultDate(args.dateStr);
        //console.log(args.dateStr);

    };

    const handleEventClick = (args) => {
        setDefaultDate(moment(args.event.start).format('YYYY-MM-DD'))
        //console.log(moment(args.event.start).format('YYYY-MM-DD'))

    };


    const handleEventClickList = e => {


        if (e.event._def.publicId != null && e.event._def.publicId != '') {
            props.history.push({
                pathname: 'request',
                state: {
                    meetingID: e.event._def.publicId
                }
            })
        }


    }


    function isDateValid(e, selectedDate) {
        var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
        //return current.day() !== 0 && current.day() !== 6;
        if (holiday != null)
            return false
        else
            return (e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate() - 1)))
    }

    function renderDay(props, currentDate, selectedDate) {
        var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
        var hdt = (holiday != null) ? holiday.name : '';

        // Adds 0 to the days in the days view
        if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0 && currentDate.day() !== 6 && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {
            props.className += ' text-danger';
            //return <td {...props} style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</td>;
            return <td >
                <button
                    onClick={e => handleHoliday(hdt)}
                    class="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
                >
                    <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
                </button>
            </td>;
        }
        else {
            return <td {...props}>{currentDate.date()}</td>;
        }
    }



    const classes = useStyles();
    return (

        <div>

            <Grid>

                <Col xs={12} sm={12} md={12}>

                    <Card>
                        <CardHeader color="primary">
                            <Grid>
                                <Col xs={12} sm={12} md={3}>
                                    <h4 className={classes.cardTitleWhite}>ปฏิทินการประชุม</h4>
                                    
                                </Col>

                                <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                                {isShowCalendar ?
                                    
                                    <TSSelect2 label="" options={ArrRoom} value={RoomKey} onChange={e => setRoomKey(e.value)} />
                                    : <></>
                                }
                                </Col>

                                <Col xs={6} sm={6} md={3} style={{ textAlign: 'right' }}>
                                    <TSCheckBox checked={isShowCalendar} onChange={e => setIsShowCalendar(!isShowCalendar)} /> {(isShowCalendar) ? <span style={{ color: 'white' }} >แสดงปฏิทิน </span> : <span style={{ color: 'white' }}>แสดงรายการ </span>}
                                </Col>
                            </Grid>
                        </CardHeader>
                        <CardBody>
                            {(!isShowCalendar) ?
                                <Grid>
                                    <Col xs={12} sm={12} md={12}>
                                        <Fullcalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                                            initialView={"listWeek"}
                                            headerToolbar={{
                                                start: "listDay,listWeek,listMonth", // will normally be on the left. if RTL, will be on the right
                                                center: "title",
                                                end: "today prev,next", // will normally be on the right. if RTL, will be on the left
                                            }}
                                            views={{
                                                listDay: { buttonText: 'วัน' },
                                                listWeek: { buttonText: 'สัปดาห์' },
                                                listMonth: { buttonText: 'เดือน' }
                                            }}
                                            hiddenDays={[0, 6]}
                                            height={"100vh"}
                                            //dateClick={handleDateClick}
                                            events={roomAll}
                                            droppable={true}
                                            rerenderDelay={10}
                                            eventDurationEditable={false}
                                            eventClick={handleEventClickList}
                                            locale={'th'}
                                            eventContent={renderEventContent2}
                                        />
                                    </Col>
                                </Grid>
                                :

                                <Grid>

                                    <Col xs={12} sm={6} md={6}>
                                        <div style={{ textAlign: 'center' }}>


                                            <Fullcalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                initialView={"dayGridMonth"}
                                                headerToolbar={{
                                                    start: "title", // will normally be on the left. if RTL, will be on the right
                                                    center: "",
                                                    end: "today prev,next", // will normally be on the right. if RTL, will be on the left
                                                }}
                                                hiddenDays={[0, 6]}
                                                height={"75vh"}
                                                dateClick={handleDateClick}
                                                events={roomAll}
                                                droppable={true}
                                                rerenderDelay={10}
                                                eventDurationEditable={false}
                                                //editable={true}
                                                //eventClick={}
                                                eventClick={handleEventClick}
                                                locale={'th'}
                                                eventContent={renderEventContent}
                                            />

                                        </div>
                                    </Col>

                                    {(RoomKey == 0 || RoomKey == 1) ?
                                        <Col xs={12} sm={6} md={6}>
                                            <Calendar
                                                defaultDate={DefaultDate} customHeader={'ห้องประชุม 1'} id={1}
                                                events={room1}
                                            />
                                        </Col>
                                        : <></>
                                    }

                                    {(RoomKey == 0 || RoomKey == 2) ?
                                        <Col xs={12} sm={6} md={6}>
                                            <Calendar
                                                defaultDate={DefaultDate} customHeader={'ห้องประชุม 2 ส่วนหน้า'} id={2}
                                                events={room2}
                                            />
                                        </Col> : <></>
                                    }

                                    {(RoomKey == 0 || RoomKey == 3) ?
                                        <Col xs={12} sm={6} md={6}>
                                            <Calendar
                                                defaultDate={DefaultDate} customHeader={'ห้องประชุม 2 ส่วนหลัง'} id={3}
                                                events={room3}
                                            />
                                        </Col> : <></>
                                    }

                                    {(RoomKey == 0 || RoomKey == 4) ?
                                        <Col xs={12} sm={6} md={6}>
                                            <Calendar
                                                defaultDate={DefaultDate} customHeader={'ห้องประชุม 3'} id={4}
                                                events={room4}
                                            />
                                        </Col> : <></>
                                    }

                                    {(RoomKey == 0 || RoomKey == 12) ?
                                        <Col xs={12} sm={6} md={RoomKey != 0 ? 6 : 6}>
                                            <Calendar
                                                defaultDate={DefaultDate} customHeader={'ห้องประชุม 4'} id={12}
                                                events={room7}
                                            />
                                        </Col> : <></>
                                    }

                                    {(RoomKey == 0 || RoomKey == 5) ?
                                        <Col xs={12} sm={6} md={RoomKey != 0 ? 6 : 6}>
                                            <Calendar
                                                defaultDate={DefaultDate} customHeader={'ห้องบุหงาตันหยง'} id={5}
                                                events={room5}
                                            />
                                        </Col> : <></>
                                    }

                                    {(RoomKey == 0 || RoomKey == 6) ?
                                        <Col xs={12} sm={6} md={RoomKey != 0 ? 6 : 6}>
                                            <Calendar
                                                defaultDate={DefaultDate} customHeader={'ห้องประชุมงานพัสดุ'} id={6}
                                                events={room6}
                                            />
                                        </Col> : <></>
                                    }
                                </Grid>
                            }
                            {/*
     <Grid>
                                 <Col xs={12} sm={12} md={12}>
                                 <TSUser value={Attendee} isMultiple={false} onChange={e => { console.log(e) } } />
                                </Col>  
                                </Grid>
*/}


                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <div>{errMsg}</div>
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>





                </Col>
            </Grid>
        </div>
    );


    function renderEventContent(eventInfo) {

        const _c = _color.find(c => c.id === eventInfo.event.extendedProps.roomKey);
        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isCancel == true) ? 'red' : _c.forecolor) : '#000000';

        const strikeTxt = (eventInfo.event.extendedProps.isCancel == true) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-time" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.timeText}</div>
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.event.title}</div>
            </>
        )
    }

    function renderEventContent2(eventInfo) {

        const _c = _color.find(c => c.id === eventInfo.event.extendedProps.roomKey);
        const _room = ArrRoom.find(c => c.value === eventInfo.event.extendedProps.roomKey);

        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isCancel == true) ? 'red' : _c.forecolor) : '#000000';
        const roomTxt = (_room !== undefined) ? _room.label : '';
        const strikeTxt = (eventInfo.event.extendedProps.isCancel == true) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.event.title} {roomTxt}</div>
            </>
        )
    }
}





export default Home;